import React from "react";
import { useSelector } from 'react-redux';
import check from '../assets/img/check.svg';

function ProgressBar() {
  const currentStep = useSelector((state) => state.settings.currentStep);
  const totalSteps = currentStep[1];
  const activeSteps = currentStep[0];

  return (
    <div className="flex items-center p-4 w-9/10 mx-auto" style={{ width: '90%' }}>
      {[...Array(totalSteps)].map((_, i) => (
        <div key={i} className="flex items-center flex-1 justify-center relative">
          {/* Circle */}
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-semibold text-sm z-10 ${i < activeSteps
              ? 'bg-evcpa-teal'
              : 'bg-evcpa-gray'
              }`}
          >
            <img src={check} alt="Check" className={`w-4 h-4 ${i < activeSteps ? 'block' : 'hidden'}`} />
          </div>

          {/* Connecting line (don't show after last circle) */}
          {i < totalSteps - 1 && (
            <div
              className={`absolute left-1/2 top-1/2 transform -translate-y-1/2 h-1.5 ${i < activeSteps - 1
                ? 'bg-evcpa-teal'
                : 'bg-evcpa-gray'
                }`}
              style={{ width: '100%', marginLeft: '16px' }}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export default ProgressBar;